import { render, staticRenderFns } from "./PrintPosFaModular.vue?vue&type=template&id=194a0371&scoped=true"
import script from "./PrintPosFaModular.vue?vue&type=script&lang=js"
export * from "./PrintPosFaModular.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaModular.vue?vue&type=style&index=0&id=194a0371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194a0371",
  null
  
)

export default component.exports